import React from 'react';
import audioRap from '../../static/audios/rap.mp3';
import imgRap from '../../static/images/section6-chanter/rappeur.png';
import video1 from '../../static/images/section3-jeunes/dei_clip.png';

export const Section6Chanter = ({ setVideoModalOpen, setVideoModalSrc }) => {
  const openModal = (src) => () => {
    setVideoModalOpen(true);
    setVideoModalSrc(src);
  };
  return (
    <section id="section6-chanter" className="py-8">
      <div className="w-10/12 m-auto">
        <div className="flex flex-col md:flex-row justify-around items-end">
          <div className="w-full md:w-3/12">
            <img src={imgRap} />
          </div>
          <div className="w-full md:w-4/12 px-8 flex flex-col pb-6 py-8">
            <h2>Chanter...</h2>
            <audio controls className="w-full block my-4">
              <source src={audioRap} type="audio/mp3" />
              Your browser does not support the audio tag.
            </audio>
            <p>Exercices de rythme et de diction, changements de flows et de tempo, pour poser des mots sur ce qu’évoque la question des VBG chez ces jeunes défendant leur liberté et l’égalité entre tous·te·s.</p>
          </div>
          <div className="video-content w-full md:w-5/12 py-4 " onClick={openModal('https://dei-videos.if3.dev/dei_clip.mp4')}>
            <img src={video1} />
            <i className="far fa-play-circle" />
          </div>
        </div>
      </div>
    </section>
  );
};
